/** Espelha ExcluirFinanceiroNotaFiscalSaidaRequest do OrquestradorVendas (POST NotaFiscalSaida/idNFeSaida/{id}/financeiro/excluir). */
export class ExcluirFinanceiroNotaFiscalSaidaRequest {
  /** Obrigatória, de 10 a 500 caracteres; vai para a ocorrência da nota e para a auditoria do Finanças. */
  justificativa: string | null = null;
}
